/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyLegalIdentifierResource } from './';
import {
    CompanyLegalIdentifierResourceFromJSON,
    CompanyLegalIdentifierResourceFromJSONTyped,
    CompanyLegalIdentifierResourceToJSON,
} from './';

/**
 * A CompanyIdentity aggregate. `primaryLegalIdentifier` is always also present inside
 * `legalIdentifiers`. All entries in `legalIdentifiers` share the same `countryCode` as
 * the primary.
 * 
 * @export
 * @interface CompanyIdentityResource
 */
export interface CompanyIdentityResource {
    /**
     * CompanyIdentityId value (Mongo ObjectId hex).
     * @type {string}
     * @memberof CompanyIdentityResource
     */
    id: string;
    /**
     * ISO-3166 alpha-2 country code of the primary legal identifier.
     * @type {string}
     * @memberof CompanyIdentityResource
     */
    countryCode: string;
    /**
     * 
     * @type {CompanyLegalIdentifierResource}
     * @memberof CompanyIdentityResource
     */
    primaryLegalIdentifier: CompanyLegalIdentifierResource;
    /**
     * All legal identifiers (the primary is included). Treated as a set; order is not significant.
     * @type {Array<CompanyLegalIdentifierResource>}
     * @memberof CompanyIdentityResource
     */
    legalIdentifiers: Array<CompanyLegalIdentifierResource>;
    /**
     * Optional VAT identification number value.
     * @type {string}
     * @memberof CompanyIdentityResource
     */
    vatNumber?: string;
}

/**
 * Check if a given object implements the CompanyIdentityResource interface.
 */
export function instanceOfCompanyIdentityResource(value: object): value is CompanyIdentityResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('primaryLegalIdentifier' in value) || value['primaryLegalIdentifier'] === undefined) return false;
    if (!('legalIdentifiers' in value) || value['legalIdentifiers'] === undefined) return false;
    return true;
}

export function CompanyIdentityResourceFromJSON(json: any): CompanyIdentityResource {
    return CompanyIdentityResourceFromJSONTyped(json, false);
}

export function CompanyIdentityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIdentityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'countryCode': json['countryCode'],
        'primaryLegalIdentifier': CompanyLegalIdentifierResourceFromJSON(json['primaryLegalIdentifier']),
        'legalIdentifiers': ((json['legalIdentifiers'] as Array<any>).map(CompanyLegalIdentifierResourceFromJSON)),
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
    };
}

export function CompanyIdentityResourceToJSON(value?: CompanyIdentityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'countryCode': value['countryCode'],
        'primaryLegalIdentifier': CompanyLegalIdentifierResourceToJSON(value['primaryLegalIdentifier']),
        'legalIdentifiers': ((value['legalIdentifiers'] as Array<any>).map((v) => CompanyLegalIdentifierResourceToJSON(v))),
        'vatNumber': value['vatNumber'],
    };
}

